/*
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-06-19 10:21:52
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2023-10-11 19:49:20
 * @FilePath: \deal\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import routerRoutes from "./routes";
import selfMsgBox from '@/components/SelfMsgBox';
// import { fnAddDynamicMenuRoutes, fnCurrentRouteIsPageRoute } from './routes'
// import { menuList } from '@/assets/mock/mock'

Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({y: 0}),
  routes: routerRoutes
})

// router.beforeEach((to, from, next) => {
  // const isLogin = true
  // if (isLogin) {
    // if (fnCurrentRouteIsPageRoute(to)) {
    //   return next()
    // }
    // fnAddDynamicMenuRoutes(menuList)
  // }
// })

router.beforeEach((to, from, next) => {
  selfMsgBox.closeAll();
  var  clientid= JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo?.clientid||'';
  //未开户
  var noHasAccount= JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo?.noHasAccount;
  var whiteList = ['/login','/forget/choseCard','/forget/resetMore','/forget/resetPassWord','/forget/activatePwd','/forget/register','/forget/goCreate','/forget/resetForm', '/bindMobile', '/bindMobile/setPswd', '/bindMobile/verifyPswd'];
  var noAccounPages=['/login','/acco-query/asset-overview','/acco-query/psw-mng','/forget/goCreate','/forget/creatAccount','/fund-trans/subscribe','/fund-trans/fund-detail', '/bindMobile', '/bindMobile/setPswd', '/bindMobile/verifyPswd'];
  //1.不需要登录可以到的页面 和登录已开户 直接放开
  if (whiteList.indexOf(to.path) !== -1||clientid&&(!noHasAccount)) { 
     next();
     return
  }
  //2.登录未开户  只能到基金详情与修改密码页面
  if (clientid&&noHasAccount&&noAccounPages.indexOf(to.path) !== -1) { 
      next();
      return
    }
  //3.登录未开户 
  if (clientid&&noHasAccount&&noAccounPages.indexOf(to.path)== -1) { 
     next('/forget/goCreate');
     return
  }
 else{
    // 支持链接跳转购买需求改造T202505234029，未登录重定向到登录页
    next({ path: '/login', query: { redirect: to.fullPath }, replace: true });
    // next('/login');
    return
}
})

export default router
